import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  
import { statusCheck } from '../public';

export const useTransactionStore = defineStore('transaction', {
  state: () => ({
    transactions: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    filters: {
      fromDate: '',
      toDate: '',
      transactionType: '',
      reference: ''
    },
    shouldResetFilters: true, // 初始化為 true
  }),
  actions: {
    async fetchTransactions(page = this.currentPage, perPage = this.itemsPerPage) {
      const url = `/api/driver/transaction/list`;
      let params = new URLSearchParams();
      
      params.append('per_page', perPage);
      params.append('page', page);

      // 格式化日期和時間
      const formatDateTime = (date) => {
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0'); // 月份補齊2位數
        const dd = String(d.getDate()).padStart(2, '0'); // 日期補齊2位數
        const hh = String(d.getHours()).padStart(2, '0'); // 小時補齊2位數
        const min = String(d.getMinutes()).padStart(2, '0'); // 分鐘補齊2位數
        const ss = String(d.getSeconds()).padStart(2, '0'); // 秒數補齊2位數

        return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`; // 返回完整日期與時間
      };

      if (this.filters.transactionType && this.filters.transactionType !== 'all') {
        params.append('transaction_type', this.filters.transactionType);
      }
      if (this.filters.fromDate) params.append('from', formatDateTime(this.filters.fromDate));
      if (this.filters.toDate) params.append('to', formatDateTime(this.filters.toDate));
      if (this.filters.reference) params.append('settlement_ref', this.filters.reference);
      
      try {
        const response = await useHttp().post(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          this.transactions = response.data.transactions;
          this.totalEntries = response.data.total;
          this.currentPage = page;
          this.itemsPerPage = perPage;
        } else {
          console.error('Failed to fetch transactions:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
      }
    },
    
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchTransactions();
      }
    },
    resetFilters() {
      this.filters.fromDate = '';
      this.filters.toDate = '';
      this.filters.transactionType = '';
      this.filters.reference = '';
    },
  },
  getters: {
    paginatedData(state) {
      return state.transactions;
    },
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },
  }
});
